import client from "./clients/portalClient";

const getAllSuppliers = () => client.get(`/product_suppliers`);
const getSupplier = (id) => client.get(`/product_suppliers/${id}`);
const getSupplierOrders = (id) => client.get(`/product_suppliers/${id}/details`);
const editExistingSupplier = (id, data) => client.put(`/product_suppliers/${id}`, data);
const postNewSupplier = (data) => client.post(`/product_suppliers`, data);

const supplierApi = {
  getAllSuppliers,
  getSupplier,
  getSupplierOrders,
  editExistingSupplier,
  postNewSupplier
};

export default supplierApi;
